import React, { useState, useRef, useContext, useEffect } from "react";
import "../styles/settings/security.css";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import {useNavigate} from "react-router-dom";

const ForgotPin = () => {
  const {
    sendOtpForTransactionPinReset,
    resetTransactionPinWithOtp,
  } = useContext(AuthContext);

 const [otpCode, setOtpCode] = useState(["", "", "", "", "", ""]);
  const [newPin, setNewPin] = useState(["", "", "", ""]);
  const [confirmPin, setConfirmPin] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [pinMismatch, setPinMismatch] = useState(false);
  const navigate = useNavigate();

  const otpRefs = useRef([]);
  const newRefs = useRef([]);
  const confirmRefs = useRef([]);

 const otpSentRef = useRef(false);

useEffect(() => {
  const sendOtp = async () => {
    if (otpSentRef.current) return; // Don't run again
    otpSentRef.current = true;

    const res = await sendOtpForTransactionPinReset();
    if (res.success) {
      toast.success(res.message);
    } else {
      toast.error(res.error || "Failed to send OTP");
    }
  };

  sendOtp();
}, []);

const handleKeyDown = (e, index, pinState, setPinState, refs) => {
  if (e.key === "Backspace" && pinState[index] === "") {
    if (index > 0) {
      refs.current[index - 1]?.focus();
    }
  }
};

  const handleChange = (index, value, pinState, setPinState, refs) => {
  if (!/^\d?$/.test(value)) return;
  const updated = [...pinState];
  updated[index] = value;
  setPinState(updated);
  if (value && index < pinState.length - 1) {
    refs.current[index + 1]?.focus();
  }
};

 const isFormValid = () => {
  const allFilled = otpCode.every(val => val !== "") &&
                    newPin.every(val => val !== "") &&
                    confirmPin.every(val => val !== "");
  const newPinMatch = newPin.join("") === confirmPin.join("");
  return allFilled && newPinMatch;
};

  useEffect(() => {
    const allFilled = newPin.every(n => n !== "") && confirmPin.every(n => n !== "");
    const match = newPin.join("") === confirmPin.join("");
    setPinMismatch(allFilled && !match);
  }, [newPin, confirmPin]);

  const handleSubmit = async () => {
    if (!isFormValid()) {
      toast.error("Please fill in all fields and ensure new PINs match.");
      return;
    }

    setLoading(true);
    const response = await resetTransactionPinWithOtp(otpCode.join(""), newPin.join(""));
    setLoading(false);

    if (response.success) {
      toast.success("PIN reset successfully!");
      setOtpCode(["", "", "", "", "", ""]);
      setNewPin(["", "", "", ""]);
      setConfirmPin(["", "", "", ""]);
      setPinMismatch(false);
       setTimeout(() => {
    navigate("/dashboard");
  }, 5000); 
    } else {
      toast.error(response.error || "Failed to reset PIN.");
    }
  };

  const renderPinInputs = (pinState, setPinState, refs, label, showError = false) => (
    <div className="pin-block">
      <p className="pin-label">{label}</p>
      <div className="pin-input-row">
        {pinState.map((val, i) => (
          <input
            key={i}
            type="password"
            inputMode="numeric"
            maxLength={1}
            value={val}
            className={`pin-input ${showError ? "error" : ""}`}
            onKeyDown={(e) => handleKeyDown(e, i, pinState, setPinState, refs)}
            ref={el => (refs.current[i] = el)}
            onChange={(e) => handleChange(i, e.target.value, pinState, setPinState, refs)}
          />
        ))}
      </div>
      {showError && (
        <p className="error-input pin-down">*New PIN and Confirm PIN do not match</p>
      )}
    </div>
  );

  return (
    <div className="security-otp-container">
      <p className="security-info-text">
        We have sent an OTP reset code to your email address. Input the code below to submit your new PIN.
      </p>

      {renderPinInputs(otpCode, setOtpCode, otpRefs, "OTP Code")}
      {renderPinInputs(newPin, setNewPin, newRefs, "New PIN")}
      {renderPinInputs(confirmPin, setConfirmPin, confirmRefs, "Confirm New PIN", pinMismatch)}

      <button
        className="change-pin-btn"
        disabled={!isFormValid() || loading}
        onClick={handleSubmit}
      >
        {loading ? "Submitting..." : "Submit New PIN"}
      </button>
    </div>
  );
};

export default ForgotPin;
